import * as React from 'react';
import Box from '@mui/material/Box';
import {
  Button, Typography,
  // ListItemIcon, MenuItem, IconButton
} from '@mui/material';
import { styled } from '@mui/material/styles';
// import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
// import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { LoadingButton } from '@mui/lab';
import * as send from '../../../../lib/analytics/send';
import { needPremium } from '../../../needPremium';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#2a2d64",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: '5px 15px',
  },
}));

const SaveScreener = ({ updatePreset, isPremium, setBanner, userUpdatedPreset, activePresetName, openPremiumMenu, handleMenuClose, activePresetDesc, saveLoading, userHasPresets, user, showPricingBanner }) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [screenerName, setScreenerName] = React.useState(activePresetName);
  const [screenerDesc, setScreenerDesc] = React.useState(activePresetDesc);
  const [labelText, setLabelText] = React.useState('Screener Name');
  const [labelDescText, setLabelDescText] = React.useState('Description');

  const handleDialogOpen = (e) => {
    // // handleMenuClose()
    // if (isPremium) {
    //   setOpen(true);
    // } else {
    //   setBanner(true);
    // }
    if (isPremium) {
      setOpen(true);
      send.uevent(e)
    } else {
      if (!userHasPresets && (user && user.accessToken)) {
        setOpen(true);
        send.uevent(e)
      } else {
        showPricingBanner(e);
        send.uevent(e, `${(user) ? `screener-pricing` : `screener-login`}-banner-open`)
      }
    }
  };

  const handleDialogClose = () => {
    setOpen(false);
    setLoading(false)
  };

  const handlePresetName = (event) => {
    event.preventDefault();
    setLoading(true)
    updatePreset(screenerName, screenerDesc)
  }

  // const handleInputChange = (event) => {
  //   const input = event.target.value;
  //   const regex = /^[a-zA-Z0-9]*$/; // Regex to allow only letters and numbers
  //   if (input.length > 0 && input[0] === ' ') { // Check if first character is a space
  //     setLabelText('Space cannot be the first character');
  //   } else if (regex.test(input)) {
  //     setScreenerName(input);
  //     setLabelText('Screener Name');
  //   } else {
  //     setLabelText('Spaces and special characters are not allowed');
  //   }
  // };

  // const handleInputChange = (event) => {
  //   const input = event.target.value;
  //   if (input.length > 0 && input[0] === ' ') {
  //     setLabelText('Text should not start with a space');
  //   } else if (/^[a-zA-Z0-9\s]*$/.test(input)) {
  //     setLabelText('Screener Name');
  //     setScreenerName(input);
  //   } else if (/^[:"!@#\$&'()*]*$/.test(input)) {
  //     setLabelText('Spaces and special characters are not allowed');
  //     setScreenerName(input);
  //   } else {
  //     setLabelText('Invalid Input');
  //   }
  // };

  const handleInputChange = (event) => {
    const input = event.target.value;
    if (input.length > 0 && input[0] === ' ') {
      setLabelText('Text should not start with a space');
    } else if (/.*/.test(input)) { // Match any character
      setLabelText('Screener Name');
      setScreenerName(input);
    } else {
      setLabelText('Invalid Input');
    }
  };

  const handleInputDescChange = (event) => {
    const input = event.target.value;
    // const regex = /^[a-zA-Z0-9 ]*$/; // Regex to allow letters, numbers, and spaces
    if (input.length > 0 && input.trim() === '') { // Check if the input consists of only spaces
      setLabelDescText('Space cannot be the first character');
    } else if (/.*/.test(input)) {
      setScreenerDesc(input);
      setLabelDescText('Description');
    } else {
      setLabelDescText('Special characters are not allowed');
    }
  };

  React.useEffect(() => {
    setOpen(false)
    setLoading(false)
  }, [userUpdatedPreset, isPremium])

  React.useEffect(() => {
    setScreenerName(activePresetName)
    setScreenerDesc(activePresetDesc)
  }, [activePresetDesc, activePresetName])

  return (
    <>
      {/* <LightTooltip describeChild title="Save as Preset" placement="top" disableInteractive>
        <IconButton onClick={handleDialogOpen} sx={{ mr: .6 }}>
          <SaveOutlinedIcon fontSize="small" sx={{ color: '#434166' }} />
        </IconButton>
      </LightTooltip> */}
      {/* <MenuItem onClick={handleDialogOpen}>
        <ListItemIcon>
          <PlaylistAddRoundedIcon fontSize="small" sx={{ color: 'primary.main' }} />
        </ListItemIcon>
        <Typography variant="inherit" noWrap sx={{ color: 'primary.main', fontSize: '.95rem', }}>Save as Preset</Typography>
      </MenuItem> */}
      <LoadingButton
        data-event-name="save-screen" data-event-category="stock-screener" data-event-label="query"
        onClick={handleDialogOpen}
        loading={saveLoading}
        size="small"
        variant="outlined"
        disableElevation
        sx={{
          color: 'primary.main', fontSize: '.875rem',
          textTransform: 'none', mx: 2,
          borderRadius: '10px',
          border: '1px solid rgba(0,0,0,0.12)',
          // width: { xs: '100%' }, whiteSpace: 'nowrap'
        }}
      >
        Save Screen
      </LoadingButton>
      <Dialog open={open} onClose={handleDialogClose}>
        {/* <DialogTitle>Save your favorite screener configurations</DialogTitle> */}
        <DialogContent>
          <DialogContentText sx={{ color: 'primary.main' }}>
            Please enter a name for your screener<br />
            <Typography variant="body2" sx={{ color: '#555' }}>
              This name will help you recognize it in your saved list of "Your Screens".
            </Typography><br />
          </DialogContentText>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            onSubmit={handlePresetName}
          >
            <TextField
              size="small"
              autoFocus
              margin="dense"
              id="name"
              helperText=""
              label={labelText}
              disabled={loading}
              type="text"
              error={labelText !== 'Screener Name'}
              fullWidth
              variant="standard"
              value={screenerName}
              onChange={handleInputChange}
              inputProps={{ maxLength: 100 }} // Limit the input to 100 characters
              sx={{ mt: 2 }}
            />
            <TextField
              size="small"
              // autoFocus
              margin="dense"
              id="desc"
              helperText=""
              label={labelDescText}
              disabled={loading}
              type="text"
              fullWidth
              error={labelDescText !== 'Description'}
              variant="standard"
              value={screenerDesc}
              onChange={handleInputDescChange}
              inputProps={{ maxLength: 100 }} // Limit the input to 100 characters
              sx={{ mt: 2 }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} size="small" sx={{ textTransform: 'none' }} onClick={handleDialogClose}>Cancel</Button>
          <Button size="small" disabled={screenerName === "" || loading} variant="contained" sx={{ textTransform: 'none' }} onClick={handlePresetName}>{loading ? `Loading...` : `Save Query`}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default needPremium(SaveScreener)
